'use client';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { socialIcons } from '@/components/ui/SocialIcon';

/** クリックでメールアドレスをコピーするカード */
const ContactMailCard = ({ email }: { email: string }) => {
  const Icon = socialIcons.email;

  const handleClick = () => {
    navigator.clipboard
      .writeText(email)
      .then(() => toast.success('アドレスをクリップボードにコピーしました'))
      .catch(() => toast.error('コピーに失敗しました'));
  };

  return (
    <>
      <button
        onClick={handleClick}
        type="button"
        className="panel panel-hover p-5 flex items-center gap-4 group text-left cursor-pointer"
      >
        <div className="flex-shrink-0 w-11 h-11 rounded-md bg-canvas border border-hairline flex items-center justify-center text-xl text-ink-muted group-hover:text-accent transition-colors">
          <Icon />
        </div>
        <div className="min-w-0">
          <p className="eyebrow">Gmail（クリックでコピー）</p>
          <p className="mt-1 text-body text-ink truncate">{email}</p>
        </div>
      </button>
      <ToastContainer theme="dark" />
    </>
  );
};

export default ContactMailCard;
